import { UniversalImporterValueObjectsImportTypeEnum } from 'generated/resources/datatable.graphql'
import { ResultValues } from 'nuvo-react'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'
import { apiClient } from 'modules/core/lib/mobx-rest'

const UNIVERSAL_IMPORTER_ENDPOINT = '/universal_importer/import_processes'

interface Props {
  data: ResultValues
  companyId: number
  importType: UniversalImporterValueObjectsImportTypeEnum
  metadata?: Record<string, (string | number | boolean)[]>
  parentProcessId?: number | null
  rootProcessId?: number | null
}

export const useSendImportResults = () => {
  const api = apiClient()
  const { performAction: sendImportResults } = useAsyncAction(
    async ({ data, metadata, companyId, importType, parentProcessId, rootProcessId }: Props) => {
      const response = await api.post(UNIVERSAL_IMPORTER_ENDPOINT, {
        data,
        metadata: metadata,
        company_id: companyId,
        import_type: importType,
        parent_process_id: parentProcessId,
        root_process_id: rootProcessId,
      })
      return response
    },
    {
      successMessage: i18n.t('universal_importer.nuvo_importer.results.success_alert'),
    }
  )

  return { sendImportResults }
}
